import { Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicText } from "@/components/DynamicText";
import { useEffect, useRef, useState } from "react";
import { getAsset } from "@/getters/getAsset";
import { isJson } from "@/functions/isJson";
import { DynamicHtml } from "@/components/DynamicHtml";

export default function Progress({ className, url_slug, project_steps }) {
  const [steps] = useState(project_steps && isJson(project_steps) ? JSON.parse(project_steps) : null);
  const firstRef = useRef();
  const lastRef = useRef();
  const verticalRef = useRef();

  useEffect(() => {
    if (steps) {
      const firstRect = firstRef.current?.getBoundingClientRect();
      const lastRect = lastRef.current?.getBoundingClientRect();
      const verticalRect = verticalRef.current?.getBoundingClientRect();

      verticalRef.current.style.height = `${Math.abs(lastRect.top - firstRect.top)}px`;
      verticalRef.current.style.transform = `translateY(${Math.abs(verticalRect.top - firstRect.top)}px)`;
    }
  }, [steps]);

  return (
    <div className={clsx(className, classes.progress)}>
      <Container fluid="lg" className="py-5 py-md-6">
        <Row>
          <Col xs={12} md={{ offset: 1, span: 10 }}>
            <DynamicText path={`page.case.study.${url_slug}.progress.title`} tag="h2" className="text-center mb-5">
              Project Progress
            </DynamicText>
            <DynamicHtml path={`page.case.study.${url_slug}.progress.text`} className="mb-5">
              <p></p>
            </DynamicHtml>
            <div className={clsx(classes.progress__steps)}>
              {steps ? (
                <>
                  <hr ref={verticalRef} className={clsx(classes.progress__steps__rule)} />
                  {steps.map(({ title, text, icon }, k) => (
                    <div className={clsx(classes.progress__step)} key={k}>
                      <div>
                        <figure>
                          <hr
                            ref={(ref) => {
                              if (k === 0) {
                                firstRef.current = ref;
                              }
                              if (k === steps.length - 1) {
                                lastRef.current = ref;
                              }
                            }}
                            className={clsx(classes.progress__step__rule)}
                          />
                          <img src={typeof icon === "string" ? icon : getAsset(icon)} alt="" />
                        </figure>
                      </div>
                      <div>
                        <h3 className="h5" dangerouslySetInnerHTML={{ __html: title }} />
                        <div dangerouslySetInnerHTML={{ __html: text }} />
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <p dangerouslySetInnerHTML={{ __html: project_steps.replace(/(?:\r\n|\r|\n)/g, "<br/><br>") }} />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
